import { defineRule } from 'vee-validate'

// ログインIDの許容文字判定
defineRule('possibleLoginId', value => {
    return value.match(/^[A-Za-z0-9+\-_.@]*$/) !== null
})

// ログインパスワードの許容文字判定
defineRule('possibleLoginPassword', value => {
    return value.match(/^[A-Za-z0-9+\-=@_]*$/) !== null
})
